import langTokens from 'applications/GSP/app/providers/TranslationProvider/lang/en.json';
import { gspApi } from 'applications/GSP/shared/api/gsp';
import { useDefaultLocale } from 'applications/GSP/shared/hooks/localization';
import { useAppSelector } from 'applications/GSP/shared/hooks/store';
import { IS_DEVELOPMENT } from 'shared/config/env';

import type { ResourceKey } from 'i18next';

export const useResources = (): ResourceKey => {
  const localeId = useDefaultLocale();
  const tokens = useAppSelector(
    state =>
      gspApi.endpoints.getApiLocalesByLocaleId.select({
        localeId,
      })(state)?.data?.tokens,
  );

  if (IS_DEVELOPMENT) {
    return langTokens;
  }

  return tokens && localeId ? tokens : {};
};
